export default __webpack_public_path__ + "static/media/unreleased5.12d97d8c.svg";